<template>
<div>
  <div class="container-title">

  </div>
  <b-table-simple class="export-table" borderless outlined>
    <b-thead>
      <b-tr class="title-row">
        <b-th colspan="5">{{ lodash.startCase($t('sale_notes.resumes.balancing')) }}</b-th>
      </b-tr>
      <b-tr>
        <b-td style="width: 1%">No</b-td>
        <b-td>{{ lodash.startCase($t('sale_notes.resumes.product_name')) }}</b-td>
        <b-td>{{ `${lodash.startCase($t('sale_notes.resumes.biomass'))} (${$t('sale_notes.resumes.kg')})` }}</b-td>
        <b-td style="text-align: right">{{ `${lodash.startCase($t('sale_notes.resumes.price'))} (/${$t('sale_notes.resumes.kg')})` }}</b-td>
        <b-td style="text-align: right;">{{ lodash.startCase($t('sale_notes.resumes.amount')) }}</b-td>
      </b-tr>
    </b-thead>
    <b-tbody>
      <b-tr v-for="({
                product_name,
                quantity,
                price,
                total_price,
                }, index) in balanceTableItems" :key="index">
        <b-td>{{ index + 1 }}</b-td>
        <b-td>{{ lodash.startCase(product_name) }}</b-td>
        <b-td>{{ decimalFormatter(quantity) }}</b-td>
        <b-td style="text-align: right">{{ currencyFormatter(price) }}</b-td>
        <b-td style="text-align: right">{{ currencyFormatter(total_price) }}</b-td>
      </b-tr>
    </b-tbody>
    <b-tfoot>
      <b-tr>
        <b-td></b-td>
        <b-td><b>{{ lodash.startCase($t('sale_notes.resumes.sub_total_sales')) }}</b></b-td>
        <b-td :class="{'text-success': totalBiomass > 0, 'text-danger': totalBiomass < 0}"
        ><b>{{ `${decimalFormatter(totalBiomass)} ${lodash.startCase($t('units.kg'))}` }}</b></b-td>
        <b-td></b-td>
        <b-td
            :class="{'text-success': totalPrice > 0, 'text-danger': totalPrice < 0}"
            style="text-align: right"
        ><b>{{ currencyFormatter(totalPrice) }}</b></b-td>
      </b-tr>
    </b-tfoot>
  </b-table-simple>
</div>
</template>

<script>
export default {
  name: 'balance-export',
  props: {
    value: { type: Object, default: function () { return {} }},
    activeTab: {type: String, default: 'admin'}
  },
  data() {
    return {
      model: this.value,
      partnerMarginVisible: true,
    }
  },
  computed: {
    isKmService () {
      return this.model?.trip?.type === 'deposit_goods'
    },
    iceCost() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category.toLowerCase() === 'cost_of_goods_sold' && sub_category === 'ice').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    deliveryCost() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category.toLowerCase() === 'expense' && sub_category === 'delivery').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    labourCost() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category.toLowerCase() === 'expense' && sub_category === 'labour').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    profitShare() {
      return this.value.profit_share?.total ?? 0
    },
    partnerDebt() {
      if (this.value.profit_share.total >= 0) return 0
      return -this.value.profit_share.total
    },
    partnerMargin() {
      let kmServiceItem = this.value.sale_items.find(({product}) => product.type === 'deposit_goods')
      if (!this.lodash.isEmpty(kmServiceItem)) return this.value.sale_operations.reduce((carry, {total}) => carry + total, 0) + this.value.profit_share.total
      return this.value.balancing_transaction?.total_debt ?? 0
    },
    jalaMargin() {
      return this.value?.sale_items?.reduce((carry, { total_service_fee }) => carry + total_service_fee, 0) ?? 0
    },
    accelerationFee() {
      return -this.value?.sale_additional_items?.filter(({ name }) => name.toLowerCase() === 'biaya percepatan').reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    pph() {
      return -this.value?.sale_additional_items?.filter(({ name }) => name.toLowerCase() === 'pph').reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    saleItems() {
      return this.value?.sale_items ?? []
    },
    balanceTableItems() {
      return this.model.sale_items.map(({
        quality,
        quantity,
        size,
        unit_price,
        total_price,
      }) => ({
        product_name: `vannamei/${this.qualityFormatter(quality)}/Size ${size}`,
        quantity: quantity,
        price: unit_price,
        total_price: total_price,
      }))
    },
    totalShrimp() {
      return this.model?.sale_item_total_initial ?? 0
    },
    totalUnload() {
      if (this.activeTab.toLowerCase() === 'admin') return this.model?.total ?? 0

      let total = this.value?.sale_items?.reduce((carry, { total_price }) => carry + total_price, 0) ?? 0

      return total + this.pph
    },
    totalBiomass() {
      return this.saleItems.reduce((carry, { quantity }) => carry + quantity, 0) ?? 0
    },
    totalPrice() {
      return this.saleItems.reduce((carry, { total_price }) => carry + total_price, 0) ?? 0
    }
  },
  methods: {
    currencyFormatter(value) {
      return this.$numeral(value).format('$ 0,0.[00]')
    },
    decimalFormatter(value) {
      return this.$numeral(value).format('0,0.[00]')
    },
    qualityFormatter(quality) {
      return ['fresh', 'merah'].includes(quality) ? this.lodash.upperFirst(quality) : this.lodash.upperCase(quality)
    }
  }
}
</script>

<style lang="scss" scoped>
table.balance-summary {
  margin: 0;
  tbody {
    tr:first-child {
      td, th {
        padding-top: 12px !important;
      }
    }
    tr:last-child {
      td, th {
        padding-bottom: 12px !important;
      }
    }
    td, th {
      padding: 4px 8px;
      background-color: #F9FAFB;
    }
  }
}
</style>